import type { AssetsConfig } from '#root/types/config/assets'

/**
 * Provides individual card image.
 * @param cardType The type of credit card.
 * @param config Mapping of credit card vendor names to asset URLs.
 * @param useGenericFallback Returns generic card image as fallback if true, return undefined otherwise.
 * @returns The image URL for the corresponding credit card type.
 * @remarks Some card types might have a common image, ex: DISCOVER|UNIONPAY
 * @category Utils
 */
export const getCreditCardImage = (cardType, config: AssetsConfig['payment']['icons']['cards'], useGenericFallback = true) => {
  if (!cardType) return config.generic
  return config?.[cardType.toLowerCase()] || (useGenericFallback ? config.generic : undefined)
}
